import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-fade' })
export class FadeText {
	private toggleStatus = 'less';
	
	private text: HTMLElement;
	private title: HTMLElement;
	private teaser: HTMLElement;

	private toggler : Element;
	private maxHeight;

	private showMoreText;
	private showLessText;


	constructor(public element: HTMLElement) {
		this.maxHeight = element.getAttribute('data-max-heigth');
		
		this.text = (element.getElementsByClassName('js-fade-text')[0] as HTMLElement);
		this.title = (element.getElementsByClassName('js-fade-title')[0] as HTMLElement);
		this.teaser = (element.getElementsByClassName('js-fade-teaser')[0] as HTMLElement);
		this.toggler = element.getElementsByClassName('js-fade-toggler')[0];
		this.showMoreText = this.toggler.getAttribute('data-showmoretext');
		this.showLessText = this.toggler.getAttribute('data-showlesstext');

		this.text.style.setProperty('--fade-max-heigth', this.maxHeight);
		addClass(this.text, "u-text-fade");
		
		if (this.text != null && this.text !== undefined && this.IsTruncated(this.text)) {
			this.CalculateLines(this.text, this.teaser, this.maxHeight);

			window.addEventListener('resize', () => {
				this.CalculateLines(this.text, this.teaser, this.maxHeight);
			});

			this.toggler.addEventListener('click', () => {
				this.ToggleText();
			});
		}
		else { 
			addClass(this.toggler, "d-none");
			removeClass(this.toggler, "d-block");

			removeClass(this.text,'u-text-fade')
		}
	}
	
	private ToggleText() {
		if (this.toggleStatus == 'less') {
			this.toggler.innerHTML = this.showLessText;
			this.toggleStatus = 'more';
			// removeClass(this.collapsedText, 'd-none');
			removeClass(this.text, 'u-text-fade');
		} else if (this.toggleStatus == 'more') {
			this.toggler.innerHTML = this.showMoreText;
			this.toggleStatus = 'less';
			// addClass(this.collapsedText, 'd-none');
			addClass(this.text, 'u-text-fade');

		}
	}

	private GetLineCount(element: HTMLElement) { 
		return element.clientHeight / window.getComputedStyle(element).lineHeight.replace('px', '');
	}

	private CalculateLines(text: HTMLElement, teaser: HTMLElement, maxHeight:number) { 
		if (this.IsTruncated(text) && this.GetLineCount(teaser) > 1) {
			text.style.setProperty('--fade-max-heigth', maxHeight - (this.GetLineCount(teaser) - 1) + '');
		} else { 
			text.style.setProperty('--fade-max-heigth', maxHeight + '');
		}
	}

	private IsTruncated(element: HTMLElement) { 
		return element.scrollHeight > element.clientHeight;
	}
}
